<template>
  <a
    style="text-decoration: none"
    :href="news.NewsURL"
    target="_blank"
    :title="news.NewsURL"
  >
    <v-sheet width="100%" class="mb-1 bg-red white">
      <v-list-item class="pd-0">
        <v-list-item-avatar tile size="30">
          <img
            src="https://pigeonpost.azurewebsites.net/Images/calendar.png"
            :title="news.NewsDate"
            alt="News Date:"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <h4 class="overline">
            {{ news.NewsDate }}
          </h4>
        </v-list-item-content>
      </v-list-item>
      <v-list-item class="pt-0">
        <v-list-item-avatar tile size="50">
          <v-img
            src="https://pigeonpost.azurewebsites.net/Images/News.png"
            :title="news.NewsURL"
            alt="News Title:"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <h4 style="font-weight: 600; color: var(--v-pageHeader-darken1)">
            <span class="title">{{ news.NewsTitle }}</span>
          </h4>

          <span class="subtitle"> {{ news.NewsDescription }}</span>
        </v-list-item-content>
      </v-list-item>
    </v-sheet>
  </a>
</template>
<script>
import { Internationalization } from "@syncfusion/ej2-base";
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  name: "NewsCard",
  data() {
    return {
      intl: new Internationalization(),
    };
  },
  props: {
    news: Object,
  },
  methods: {
    shadeColor(color, percentage) {
      return customFunctions.shadeColor(color, percentage);
    },
    openNewsLink(url) {
      alert(url);
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.target = "_blank";
      a.href = url;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    getTimeDetails(mDetails) {
      return (
        this.intl.formatDate(new Date(mDetails.scheduletStartTimeInUTC), {
          type: "date",
          skeleton: "long",
        }) +
        " (" +
        this.intl.formatDate(new Date(mDetails.scheduletStartTimeInUTC), {
          skeleton: "hm",
        }) +
        " - " +
        this.intl.formatDate(new Date(mDetails.scheduledEndTimeInUTC), {
          skeleton: "hm",
        }) +
        ")"
      );
    },
  },
};
</script>
<style scoped>
::v-deep .v-list-item {
  min-height: 0px !important;
  padding-top: 5px;
}
::v-deep .overline {
  line-height: 1rem !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.0666666667em !important;
}
::v-deep .mChip {
  padding: 0 10px;
  margin: 0 20px;
  font-size: 0.85rem !important;
}
::v-deep .v-list-item__content {
  padding: 5px 0 !important;
}
</style>